"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentMethodCodes = void 0;
const enums_1 = require("../enums");
exports.paymentMethodCodes = {
    BANK: {
        code: enums_1.PaymentMethodCode.BANK,
        displayCode: 'BANK',
        bcCode: 'BANK',
        description: 'By bank',
        applicableBillingEntities: [
            enums_1.BillingEntityCode.FORTO_VN,
            enums_1.BillingEntityCode.FORTO_CN,
            enums_1.BillingEntityCode.FORTO_NGB,
            enums_1.BillingEntityCode.FORTO_TSN,
            enums_1.BillingEntityCode.FORTO_SZX,
            enums_1.BillingEntityCode.FORTO_SHA,
        ],
    },
    CASH: {
        code: enums_1.PaymentMethodCode.CASH,
        displayCode: 'CASH',
        bcCode: 'CASH',
        description: 'Cash',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_ES],
    },
    CUSTOMS: {
        code: enums_1.PaymentMethodCode.CUSTOMS,
        displayCode: 'CUSTOMS',
        bcCode: 'CUSTOMS',
        description: 'Customs Deferment Account',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_DE],
    },
    DTAZV_COGS: {
        code: enums_1.PaymentMethodCode.DTAZV_COGS,
        displayCode: 'DTAZV-COGS',
        bcCode: 'DTAZV-COGS',
        description: 'International Bank Transfer COGS',
        applicableBillingEntities: [
            enums_1.BillingEntityCode.FORTO_DE,
            enums_1.BillingEntityCode.FORTO_IT,
            enums_1.BillingEntityCode.FORTO_NL,
            enums_1.BillingEntityCode.FORTO_ZOEY,
            enums_1.BillingEntityCode.FORTO_PL,
        ],
    },
    DTAZV_CUST: {
        code: enums_1.PaymentMethodCode.DTAZV_CUST,
        displayCode: 'DTAZV-CUST',
        bcCode: 'DTAZV-CUST',
        description: 'International Bank Transfer CUSTOMS',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_DE, enums_1.BillingEntityCode.FORTO_PL],
    },
    ISO_PMT: {
        code: enums_1.PaymentMethodCode.ISO_PMT,
        displayCode: 'ISO PMT',
        bcCode: 'ISO PMT',
        description: 'ISO Payment',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_NL, enums_1.BillingEntityCode.FORTO_ZOEY],
    },
    SAN_EUR: {
        code: enums_1.PaymentMethodCode.SAN_EUR,
        displayCode: 'SAN EUR',
        bcCode: 'SAN EUR',
        description: 'Santander Payment EUR',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_PL],
    },
    SAN_PLN: {
        code: enums_1.PaymentMethodCode.SAN_PLN,
        displayCode: 'SAN PLN',
        bcCode: 'SAN PLN',
        description: 'Santander Payment PLN',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_PL],
    },
    SAN_USD: {
        code: enums_1.PaymentMethodCode.SAN_USD,
        displayCode: 'SAN USD',
        bcCode: 'SAN USD',
        description: 'Santander Payment USD',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_PL],
    },
    SEPA_COGS: {
        code: enums_1.PaymentMethodCode.SEPA_COGS,
        displayCode: 'SEPA-COGS',
        bcCode: 'SEPA-COGS',
        description: 'Bank Transfer COGS',
        applicableBillingEntities: [
            enums_1.BillingEntityCode.FORTO_DE,
            enums_1.BillingEntityCode.FORTO_ES,
            enums_1.BillingEntityCode.FORTO_IT,
            enums_1.BillingEntityCode.FORTO_NL,
            enums_1.BillingEntityCode.FORTO_PL,
            enums_1.BillingEntityCode.FORTO_ZOEY,
        ],
    },
    SEPA_CUST: {
        code: enums_1.PaymentMethodCode.SEPA_CUST,
        displayCode: 'SEPA-CUST',
        bcCode: 'SEPA-CUST',
        description: 'Bank Transfer CUSTOMS',
        applicableBillingEntities: [
            enums_1.BillingEntityCode.FORTO_DE,
            enums_1.BillingEntityCode.FORTO_IT,
            enums_1.BillingEntityCode.FORTO_NL,
            enums_1.BillingEntityCode.FORTO_PL,
        ],
    },
    STANDING_ORDER: {
        code: enums_1.PaymentMethodCode.STANDING_ORDER,
        displayCode: 'SO',
        bcCode: 'SO',
        description: 'Standing Order',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_DE, enums_1.BillingEntityCode.FORTO_ES, enums_1.BillingEntityCode.FORTO_PL],
    },
    WIRE: {
        code: enums_1.PaymentMethodCode.WIRE,
        displayCode: 'WIRE',
        bcCode: 'WIRE',
        description: 'Wire',
        applicableBillingEntities: [enums_1.BillingEntityCode.FORTO_ES, enums_1.BillingEntityCode.FORTO_IT, enums_1.BillingEntityCode.FORTO_PL],
    },
};
//# sourceMappingURL=data:application/json;base64,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